/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OrganisationGroupResponse } from "./OrganisationGroupResponse";
import {
    OrganisationGroupResponseFromJSON,
    OrganisationGroupResponseFromJSONTyped,
    OrganisationGroupResponseToJSON,
} from "./OrganisationGroupResponse";
import type { OrganisationResponse } from "./OrganisationResponse";
import {
    OrganisationResponseFromJSON,
    OrganisationResponseFromJSONTyped,
    OrganisationResponseToJSON,
} from "./OrganisationResponse";

/**
 *
 * @export
 * @interface OrganisationsResponse
 */
export interface OrganisationsResponse {
    /**
     * True if this is the complete list of tags. This is the case if you are allowed to see all tags in the system (ie you are admin, or mineOnly=false)
     * @type {boolean}
     * @memberof OrganisationsResponse
     */
    isComplete?: boolean;
    /**
     *
     * @type {Array<OrganisationGroupResponse>}
     * @memberof OrganisationsResponse
     */
    organisationGroups?: Array<OrganisationGroupResponse>;
    /**
     *
     * @type {Array<OrganisationResponse>}
     * @memberof OrganisationsResponse
     */
    organisations?: Array<OrganisationResponse>;
}

/**
 * Check if a given object implements the OrganisationsResponse interface.
 */
export function instanceOfOrganisationsResponse(
    value: object,
): value is OrganisationsResponse {
    return true;
}

export function OrganisationsResponseFromJSON(
    json: any,
): OrganisationsResponse {
    return OrganisationsResponseFromJSONTyped(json, false);
}

export function OrganisationsResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrganisationsResponse {
    if (json == null) {
        return json;
    }
    return {
        isComplete: json["isComplete"] == null ? undefined : json["isComplete"],
        organisationGroups:
            json["organisationGroups"] == null
                ? undefined
                : (json["organisationGroups"] as Array<any>).map(
                      OrganisationGroupResponseFromJSON,
                  ),
        organisations:
            json["organisations"] == null
                ? undefined
                : (json["organisations"] as Array<any>).map(
                      OrganisationResponseFromJSON,
                  ),
    };
}

export function OrganisationsResponseToJSON(
    value?: OrganisationsResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        isComplete: value["isComplete"],
        organisationGroups:
            value["organisationGroups"] == null
                ? undefined
                : (value["organisationGroups"] as Array<any>).map(
                      OrganisationGroupResponseToJSON,
                  ),
        organisations:
            value["organisations"] == null
                ? undefined
                : (value["organisations"] as Array<any>).map(
                      OrganisationResponseToJSON,
                  ),
    };
}
